// import React, { useState } from "react";
// import { shortenUrl } from "../api";

// const ShortenUrlForm = ({ onUrlShortened }) => {
//     const [originalUrl, setOriginalUrl] = useState(""); 
//     const [shortUrl, setShortUrl] = useState(""); 

//     const handleSubmit = async (e) => { 
//         e.preventDefault();
//         const result = await shortenUrl(originalUrl);
//         if (result) {
//             setShortUrl(result.shortUrl);
//             onUrlShortened(); // Actualizar lista de URLs
//         }
//     };

//     return (
//         <div className="max-w-lg mx-auto bg-white shadow-lg rounded-lg p-6">
//             <h2 className="text-2xl font-bold text-gray-700 text-center">Acortador de URLs</h2>
//             <form onSubmit={handleSubmit} className="mt-4">
//                 <input 
//                     type="url" 
//                     placeholder="Introduce tu URL larga..."
//                     value={originalUrl}
//                     onChange={(e) => setOriginalUrl(e.target.value)}
//                     required 
//                     className="w-full px-4 py-2 border rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
//                 />
//                 <button 
//                     type="submit" 
//                     className="w-full bg-blue-500 text-white font-bold py-2 px-4 rounded-lg mt-3 hover:bg-blue-600 transition">
//                     Acortar
//                 </button>
//             </form>

//             {shortUrl && (
//                 <div className="mt-4 text-center">
//                     <p className="text-gray-600">URL corta generada:</p>
//                     <a href={shortUrl} target="_blank" rel="noopener noreferrer" className="text-blue-500 font-bold">
//                         {shortUrl}
//                     </a>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default ShortenUrlForm;



import React, { useState } from "react";
import { shortenUrl } from "../api";

const ShortenUrlForm = ({ onUrlShortened }) => {
    const [originalUrl, setOriginalUrl] = useState("");
    const [shortUrl, setShortUrl] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        const result = await shortenUrl(originalUrl);
        if (result) {
            setShortUrl(result.shortUrl);
            onUrlShortened();
        }
    };

    return (
        <div className="max-w-lg w-full bg-gray-900 shadow-lg rounded-xl p-6 border border-gray-700 hover:border-blue-500 transition">
            <h2 className="text-2xl font-bold text-blue-400 text-center mb-4">🌐 Acortar URL</h2>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                <input 
                    type="url" 
                    placeholder="Introduce tu URL..."
                    value={originalUrl}
                    onChange={(e) => setOriginalUrl(e.target.value)}
                    required 
                    className="w-full px-4 py-3 bg-gray-800 text-white border border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:outline-none"
                />
                <button 
    type="submit" 
    className="w-full bg-[#0A80BA] text-white font-bold py-3 rounded-lg hover:bg-[#E1EBF1] hover:text-[#0A80BA] hover:scale-105 transition">
    🚀 Generar Enlace
</button>
            </form>

            {shortUrl && (
                <div className="mt-4 text-center">
                    <p className="text-gray-400">✅ URL Acortada:</p>
                    <a href={shortUrl} target="_blank" rel="noopener noreferrer" className="text-blue-400 font-bold hover:underline">
                        {shortUrl}
                    </a>
                </div>
            )}
        </div>
    );
};

export default ShortenUrlForm;

